import { render, staticRenderFns } from "./DropOffs.vue?vue&type=template&id=3ea97348&scoped=true&"
import script from "./DropOffs.vue?vue&type=script&lang=ts&"
export * from "./DropOffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea97348",
  null
  
)

export default component.exports